import parsePhoneNumber from 'libphonenumber-js';

const ALLOWED_COUNTRIES = ['US', 'CA'];

export const checkPhoneNumberRequirements = (
  phoneNumberInput = '',
): boolean => {
  try {
    const phoneNumber = parsePhoneNumber(phoneNumberInput);
    return !!(phoneNumber && phoneNumber.isValid());
  } catch {
    return false;
  }
};

export const checkIsValidCountry = (phone: string): boolean => {
  const phoneNumber = parsePhoneNumber(phone);
  return !!(
    phoneNumber && ALLOWED_COUNTRIES.includes(phoneNumber.country as string)
  );
};
